/* Scoped, server-rendered inventory refresh. No fabricated stock or timers. */
if (!customElements.get('urgency-stock-bar')) {
  customElements.define('urgency-stock-bar', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.source !== 'inventory') return;
      this.connectToTheme();
    }
    connectToTheme() {
      if (!this.isConnected) return;
      if (!window.theme?.pubsub?.subscribe) {
        this.retry = setTimeout(() => this.connectToTheme(), 100);
        return;
      }
      this.unsubscribe = window.theme.pubsub.subscribe(window.theme.pubsub.PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (String(data.sectionId) !== this.dataset.sectionId || String(data.productId) !== this.dataset.productId) return;
        const fresh = data.parsedHTML?.getElementById(this.id)?.querySelector('[data-stock-content]');
        const current = this.querySelector('[data-stock-content]');
        if (fresh && current) current.replaceWith(fresh.cloneNode(true));
      });
      // Pubsub survives picker subtree replacement and handles dropdowns as well.
      this.unsubscribeSelection = window.theme.pubsub.subscribe(window.theme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
        const picker = data.target?.closest('variant-picker');
        if (picker?.id !== `VariantPicker-${this.dataset.sectionId}-${this.dataset.productId}`) return;
        const content = this.querySelector('[data-stock-content]');
        if (content) content.hidden = true;
      });
    }
    disconnectedCallback() {
      clearTimeout(this.retry);
      this.unsubscribe?.();
      this.unsubscribeSelection?.();
    }
  });
}
